<template>
  <div>
    <div v-if="EmptyObject(company)" class="sub-form">
      <div class="ttl-job">Search Company</div>
      <div class="ttl-inp">
        <v-autocomplete
          outline
          solo
          clearable
          hide-no-data
          append-icon="search"
          label="search"
          :search-input.sync="query"
          :items="company_items"
          item-text="company_name"
          return-object
          v-model="company"
        >
        </v-autocomplete>
      </div>
    </div>
    <div class="sub-form2" v-else>
      <div class="row nv justify-content-center">
        <div
          v-bind:class="[{ act: tab === 1 }]"
          @click="selectTab(1)"
          class="col-2 itm"
        >
          Active
        </div>
        <div
          v-bind:class="[{ act: tab === 2 }]"
          @click="selectTab(2)"
          class="col-2 itm"
        >
          Approved
        </div>
        <div
          v-bind:class="[{ act: tab === 3 }]"
          @click="selectTab(3)"
          class="col-2 itm"
        >
          Draft
        </div>
        <div
          v-bind:class="[{ act: tab === 4 }]"
          @click="selectTab(4)"
          class="col-2 itm"
        >
          Pending
        </div>
        <div
          v-bind:class="[{ act: tab === 5 }]"
          @click="selectTab(5)"
          class="col-2 itm"
        >
          Expired
        </div>
        <div @click="resetAll" class="col-1 itmB">Back</div>
      </div>
      <div>
        <active-jobs v-if="tab === 1" v-bind:company_id="company.company_id">
        </active-jobs>
        <approved-jobs v-if="tab === 2" v-bind:company_id="company.company_id">
        </approved-jobs>
        <draft-jobs v-if="tab === 3" v-bind:company_id="company.company_id">
        </draft-jobs>
        <pending-jobs v-if="tab === 4" v-bind:company_id="company.company_id">
        </pending-jobs>
        <expired-jobs v-if="tab === 5" v-bind:company_id="company.company_id">
        </expired-jobs>
      </div>
    </div>
  </div>
</template>

<script>
import { AUTO_SUGGEST_COMPANY_COMPLIANCE } from "../../../Api/admin_api";
import { IsEmptyObject } from "../../../globalFunctions";
import ActiveJobs from "../../employer/jobs/active/active-jobs";
import ApprovedJobs from "../../employer/jobs/approved/approved-jobs";
import DraftJobs from "../../employer/jobs/draft/draft-jobs";
import PendingJobs from "../../employer/jobs/pending/pending-jobs";
import ExpiredJobs from "../../employer/jobs/expired/expired-jobs";
export default {
  name: "main-page",
  components: {
    ActiveJobs,
    ApprovedJobs,
    DraftJobs,
    PendingJobs,
    ExpiredJobs,
  },
  data: function () {
    return {
      query: "",
      company_items: [],
      company: {},
      EmptyObject: IsEmptyObject,
      tab: 1,
    };
  },
  methods: {
    selectTab(tab) {
      const self = this;
      self.tab = tab;
    },
    getCompany(v) {
      const self = this;
      AUTO_SUGGEST_COMPANY_COMPLIANCE(v)
        .then(function (data) {
          self.company_items = data;
        })
        .catch(function (data) {});
    },
    resetAll() {
      const self = this;
      self.company_items = [];
      self.company = {};
    },
  },
  watch: {
    query(val) {
      if (val === null) {
        this.resetAll();
      }
      val && this.getCompany(val);
    },
  },
};
</script>

<style scoped>
.sub-form {
  max-width: 80rem;
  margin: auto;
}
.sub-form2 {
  margin: 0 2rem;
}
.ttl-job {
  text-align: left;
  font-size: 1.6rem;
  color: #050505;
}
.ttl-inp {
  text-align: left;
  padding: 0.5rem 0;
}
.nv {
  padding: 0.5rem !important;
  color: white;
  border-radius: 0.5rem;
  margin-bottom: 2rem !important;
}
.itm {
  background-color: var(--job-select-back);
  margin: 0 0.5rem;
  padding: 1rem;
  color: var(--job-select-color);
  cursor: pointer;
  font-weight: bold;
}
.itmB {
  background-color: var(--button-delete-unfocus);
  margin: 0 0.5rem;
  padding: 1rem;
  color: var(--button-delete-color);
  cursor: pointer;
}
.act {
  background-color: var(--job-select-color);
  color: white;
}
</style>
